import script from "./virus-distribution-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./virus-distribution-chart.vue?vue&type=script&lang=ts&setup=true"

import "./virus-distribution-chart.vue?vue&type=style&index=0&id=f4eff70c&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4eff70c"]])

export default __exports__